var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRdOperatingManuals(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu_book_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2658",
    "data-name": "Group 2658"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1983",
    "data-name": "Rectangle 1983",
    className: "cls-1",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2661",
    "data-name": "Group 2661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2660",
    "data-name": "Group 2660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4478",
    "data-name": "Path 4478",
    d: "M21,5a11.8,11.8,0,0,0-3.5-.5A9.3,9.3,0,0,0,12,6,9.3,9.3,0,0,0,6.5,4.5,9.3,9.3,0,0,0,1,6V20.65a.538.538,0,0,0,.5.5c.1,0,.15-.05.25-.05A12.205,12.205,0,0,1,6.5,20,9.3,9.3,0,0,1,12,21.5,12.045,12.045,0,0,1,17.5,20a10.178,10.178,0,0,1,4.75,1.05.451.451,0,0,0,.25.05.538.538,0,0,0,.5-.5V6A6.821,6.821,0,0,0,21,5Zm0,13.5a11.62,11.62,0,0,0-3.5-.5A12.045,12.045,0,0,0,12,19.5V8a12.045,12.045,0,0,1,5.5-1.5A11.62,11.62,0,0,1,21,7Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2659",
    "data-name": "Group 2659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4479",
    "data-name": "Path 4479",
    d: "M17.5,10.5a11.694,11.694,0,0,1,2.5.26V9.24A13.5,13.5,0,0,0,17.5,9a11.507,11.507,0,0,0-4.5.83v1.66A9.283,9.283,0,0,1,17.5,10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4480",
    "data-name": "Path 4480",
    d: "M13,12.49v1.66a9.283,9.283,0,0,1,4.5-.99,11.694,11.694,0,0,1,2.5.26V11.9a13.5,13.5,0,0,0-2.5-.24A11.691,11.691,0,0,0,13,12.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4481",
    "data-name": "Path 4481",
    d: "M17.5,14.33a11.507,11.507,0,0,0-4.5.83v1.66a9.283,9.283,0,0,1,4.5-.99,11.694,11.694,0,0,1,2.5.26V14.57A12.7,12.7,0,0,0,17.5,14.33Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdOperatingManuals);
export default __webpack_public_path__ + "static/media/rd-operating-manuals.575d30e42efeae0c1655eedf7e6a986f.svg";
export { ForwardRef as ReactComponent };